<section class="relative lg:flex md:sm:grid md:sm:grid-cols-1 items-center gap-4">
  <article class="lg:flex rounded h-10">
    <app-input-search [searchValue]="searchValue" [placeholder]="placeholder" (submitEventEmitter)="search($event)"></app-input-search>
  </article>
  <article class="lg:flex items-center">
    <app-custom-toggle
      [id]="'communications-type-toggle'"
      [selectedValue]="communicationType"
      [options]="communicationTypeToggleOptions"
      (action)="toggleCommunicationType()"
    />
  </article>
  @if (adminRole == 'SUPERADMIN' || adminRole == 'ADMIN') {
    <article class="lg:flex items-center">
      <app-custom-toggle
        [id]="'communications-header-toggle'"
        [selectedValue]="communicationUserType"
        [options]="communicationUserTypeToggleOptions"
        (action)="changeCommunicationUserType($any($event))"
      />
    </article>
  }
  <article class="relative lg:flex rounded" (click)="filterOpened = !filterOpened">
    <button id="buttonOpenFilter" class="search-bar-button text-gray-800 font-bold px-4 py-2 rounded inline-flex items-center gap-2"
      [ngClass]="{ 'opened' : filterOpened || filtersApplied > 0, 'filtersApplied': filtersApplied > 0 }">
      <img [src]="images.filter" alt="filter" class="w-6 h-6" [ngClass]="{ 'filter-primary-purple-light': filterOpened }" />
      <span class="font-semibold text-base">{{ literalService.get("communications.filter", true) }}</span>
      @if (filtersApplied > 0) {
        <span class="font-bold text-primary-purple-light text-[14px]">
          ({{ filtersApplied }})
        </span>
      }
    </button>
  </article>
  @if (communicationType === CommunicationTypes.SUGGESTIONS) {
    <article class="flex absolute top-0 left-0 mt-15 w-max max-w-[calc(100vw-8rem)] z-10" [ngClass]="{ 'hidden': !filterOpened}">
      <app-filter-panel [componentOpen]="'buttonOpenFilter'"
        [fields]="suggestionFilterFields"
        [filterType]="filterTypes.SUGGESTIONS"
        [communicationUserType]="communicationUserType"
        (filter)="onSuggestionsFilter($event)"
        (closeFilter)="closeFilter()"
      />
    </article>
  }
  @else {
    <article class="flex absolute top-0 left-0 mt-20 w-max max-w-[calc(100vw-8rem)] z-10" [ngClass]="{ 'hidden': !filterOpened}">
      <app-filter-panel [componentOpen]="'buttonOpenFilter'"
        [fields]="messageFilterFields"
        [filterType]="filterTypes.MESSAGES"
        [communicationUserType]="communicationUserType"
        (filter)="onMessagesFilter($event)"
        (closeFilter)="closeFilter()"
      />
    </article>
  }
  @if (communicationType === CommunicationTypes.SUGGESTIONS) {
    <article id="sort" class="relative lg:flex rounded" (click)="sortedOpened = !sortedOpened">
      <button id="buttonOpenSort" class="search-bar-button text-gray-800 font-bold px-4 py-2 rounded inline-flex items-center gap-2">
        <img [src]="images.sort" alt="sort" class="w-6 h-6" />
        <span class="font-semibold text-base">{{
          literalService.get("communications.sort", true)
          }}</span>
      </button>
      <article id="sortModal" class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !sortedOpened }">
        <app-option-selector [id]="'suggestionsSortSelector'" [componentOpen]="'buttonOpenSort'" [title]="'orderBy'" [selectedOption]="suggestionSortTypeSelected" [options]="sortOptions" (onChange)="handleSort($event)" (close)="sortedOpened = false" ></app-option-selector>
      </article>
    </article>
  }
  @if (searching) {
    <article class="flex items-center">
      <img [src]="images.loading" alt="loading" class="h-8 w-8 ml-4" />
      <label class="font-semibold text-base ml-4">{{ literalService.get(`communications.searching`, true) }}...</label>
    </article>
  }
  <section class="flex ml-auto max-h-10">
    <article
      class="lg:flex w-full rounded-[30px] px-3 py-1.5 inline-flex gap-1.5 justify-center items-center ml-auto cursor-pointer outlinedButton"
      (click)="addCommunicationEventEmitter.emit()"
    >
      <img [src]="images.suggestions.addSuggestion" alt="addSuggestion" class="w-5.5 h-5.5" />
      <span class="font-semibold text-base"> {{ literalService.get(`${communicationType}.new`, true) }} </span>
    </article>
  </section>
</section>